module.exports = __webpack_public_path__ + "static/img/code.6cb0dbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/foot/code.png
// module id = HTWL
// module chunks = 7